import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';

const Home: React.FC = () => {
  const exploreLinks = [
    {
      to: '/shows',
      meta: '01 // TOUR DATES',
      title: 'Live Shows',
      description: 'Find upcoming performances, past venues, and detailed personnel lists for every gig.'
    },
    {
      to: '/map',
      meta: '02 // GIG MAP',
      title: 'Interactive Map',
      description: 'Explore a visual geography of all the stages, cities, and locations Jordan has played.'
    },
    {
      to: '/media',
      meta: '03 // GALLERY',
      title: 'Media',
      description: 'Browse performance photos and gallery shots of Jordan playing live on stage.'
    },
    {
      to: '/about',
      meta: '04 // BIOGRAPHY',
      title: 'About Jordan',
      description: 'Discover the background, dedication, and story behind Jordan’s musical journey.'
    }
  ];

  return (
    <div>
      <HeroSection 
        imageUrl="https://jordan-site-photos.s3.us-east-1.amazonaws.com/photo1.jpg"
        title="Jordan Molacek"
        subtitle="Pedal Steel Guitarist"
        ctaText="View Gigs"
        ctaLink="/shows"
      />
      <div className="page-container">
        <div className="explore-section">
          <h2 className="explore-section-title">Explore</h2>
          <div className="explore-grid">
            {exploreLinks.map((link, idx) => (
              <Link key={idx} to={link.to} className="explore-card">
                <div>
                  <div className="explore-card-meta">{link.meta}</div>
                  <h3 className="explore-card-title">
                    {link.title} <span className="arrow">→</span>
                  </h3>
                  <p className="explore-card-description">{link.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
